import React from "react"
import { Box, Typography, makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  primaryText: {
    color: theme.palette.primary.dark,
    fontFamily: theme.typography.h1.fontFamily,
    fontWeight: 500,
    fontSize: "60px",
    letterSpacing: "-0.3px",
    lineHeight: "68px",
    marginBottom: theme.spacing(4),
  },
  secondaryText: {
    color: theme.palette.text.primary,
    fontWeight: "400",
    fontSize: "30px",
    letterSpacing: "-0.1px",
    lineHeight: "36px",
    marginBottom: theme.spacing(2),
  },
  formField: {
    marginBottom: theme.spacing(1),
  },
}))

const Hero = ({
  textAlign = "center",
  primaryText,
  secondaryText
}) => {
  const classes = useStyles()

  return (
    <Box
      display="flex"
      flexDirection="column"
      textAlign={textAlign}
      justifyContent="center"
      alignItems="center"
      minHeight={400}
    >
      <Typography className={classes.primaryText} variantMapping="h1">
        {primaryText}
      </Typography>
      <Typography className={classes.secondaryText}>{secondaryText}</Typography>
    </Box>
  )
}

export default Hero
